import React from "react";
import AllEvents from "../../components/Shop/AllEvents";

const ProfileEvents = () => {
  return <AllEvents />;
};

export default ProfileEvents;

